package com.essntl.features.message.domain.useCase

import com.essntl.features.message.domain.model.WhapiChatModel
import com.essntl.uikit.components.chat.conversation.ConversationFilterOptions

object SortConversations {
    operator fun invoke(
        conversations: List<WhapiChatModel>,
        filterOptions: ConversationFilterOptions,
    ): List<WhapiChatModel> {
        return conversations.sortedWith(
            compareByDescending { it.lastMessage?.timestamp },
        )
    }
}